export default __webpack_public_path__ + "images/EC.86fe1a1.png";